export default {"src":"/_next/static/media/generic.f2b7a1fa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};